import { DiscoveryInitialPanel } from '../containers/discovery-initial-panel';
import { Scene, Stage } from '@/shared/components/stage/stage';
import { FlowerSpinner } from '@/shared/components/loader/flower-spinner';
import { useDiscoveryStore } from '../stores/discovery-store';
import { DiscoverySearchContainer } from '../containers/discovery-search-container';
import { useDiscoverySessionRouting } from '../hooks';
import { useSearch } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

export const DiscoveryPage = () => {
  const { prompt } = useSearch({ from: '/workspace/$workspaceId/discovery/' });
  const { viewState, session, setPrompt, setViewState } = useDiscoveryStore();
  const appliedPromptKeyRef = useRef<string | null>(null);

  useDiscoverySessionRouting();

  useEffect(() => {
    if (!prompt || !session) {
      appliedPromptKeyRef.current = null;
      return;
    }

    const promptKey = `${session.session_id}:${prompt}`;
    if (appliedPromptKeyRef.current === promptKey) return;

    setPrompt(prompt);
    setViewState('idle');
    appliedPromptKeyRef.current = promptKey;
  }, [prompt, session, setPrompt, setViewState]);

  return (
    <Stage className="bg-background flex h-screen w-full flex-col overflow-hidden">
      <Scene data={viewState === 'idle' ? session : null}>
        {(session) => (
          <main className="flex min-h-0 flex-1 items-center justify-center px-6">
            <DiscoveryInitialPanel session={session} />
          </main>
        )}
      </Scene>
      <Scene data={viewState === 'chat' ? session : null}>
        {(session) => <DiscoverySearchContainer session={session} />}
      </Scene>
      <Scene default className="items-center justify-center">
        <FlowerSpinner />
      </Scene>
    </Stage>
  );
};
